/** PURE_IMPORTS_START ._EmptyObservable PURE_IMPORTS_END */
import { EmptyObservable } from './EmptyObservable';
export var empty = EmptyObservable.create;
//# sourceMappingURL=empty.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/empty.js
// module id = 368
// module chunks = 0